module.exports = __webpack_public_path__ + "static/icon_bottom_1.a3ba30ba.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon_bottom_1.png
// module id = 1039
// module chunks = 2